import { Download, KeyRound, MousePointerClick } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
    {
        icon: MousePointerClick,
        num: "01",
        title: "Pulsa Google Play",
        text: "Toca el botón de Google Play y te llevamos directos a la ficha de la app.",
    },
    {
        icon: Download,
        num: "02",
        title: "Instala la app (gratis)",
        text: "La descarga es gratuita y ocupa muy poco. En menos de un minuto la tienes.",
    },
    {
        icon: KeyRound,
        num: "03",
        title: "Encuentra tu piso",
        text: "Explora pisos y casas en toda España y habla con nosotros por WhatsApp.",
    },
];

export const Steps = () => (
    <section
        id="como-funciona"
        className="bg-brand-cream py-20 dark:bg-brand-night sm:py-28"
        data-testid="steps-section"
    >
        <div className="mx-auto max-w-6xl px-5">
            <SectionHeading
                kicker="En 3 pasos"
                title="Descargar es muy fácil"
                sub="Sin registros, sin formularios y sin pagos. Así de simple."
            />
            <div className="mt-12 grid gap-6 md:grid-cols-3 md:gap-8">
                {STEPS.map((step, i) => (
                    <Reveal key={step.num} delay={i * 0.12}>
                        <div
                            className="group relative h-full overflow-hidden rounded-2xl border border-brand-navy/10 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                            data-testid={`step-card-${i + 1}`}
                        >
                            <span
                                aria-hidden="true"
                                className="pointer-events-none absolute -right-3 -top-6 font-sans text-8xl font-black text-brand-navy/5 transition-colors duration-300 group-hover:text-brand-orange/10 dark:text-white/5"
                            >
                                {step.num}
                            </span>
                            <span className="inline-flex rounded-xl bg-brand-orange/10 p-3 text-brand-orange">
                                <step.icon className="h-6 w-6" strokeWidth={2.2} />
                            </span>
                            <h3 className="mt-5 font-sans text-xl font-bold text-brand-navy dark:text-white">
                                {step.title}
                            </h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-brand-navy/70 dark:text-white/60">
                                {step.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
